import React from 'react';
import { Burger } from '@lt/components/icons-react/rebrand';
import type { Menu } from 'src/store/menu/types';
import { isPartner } from 'src/helpers/isPartner';

import type { CLIENT } from '@lt/api/dist/types/client';
import DesktopMenu from './components/DesktopMenu';
import MobileMenu from './components/MobileMenu';

interface Props {
  isMobile: LT.isMobile;
  isWhitelabel?: boolean;
  menu: Menu;
  className?: string;
  isCollapsed?: boolean;
  isHideMenu?: boolean;
  isHideFeedback: boolean;
  openSidebar?: () => void;
  isHomepage?: boolean;
  logIn: (client: CLIENT) => void;
}

const HeaderMenu = ({
  isMobile,
  isWhitelabel = false,
  isHideMenu = false,
  menu,
  className,
  isCollapsed,
  openSidebar,
  isHideFeedback,
  isHomepage,
  logIn,
}: Props): JSX.Element | null => {
  if (isHideMenu) {
    return null;
  }

  // Кастомизируем меню для Мосгортура и Cosmos Travel
  const help = menu?.help && { ...menu.help };
  if (
    help &&
    help.items &&
    (isPartner('mosgortur') ||
      isPartner('mosgortur_public') ||
      isPartner('cosmos_travel'))
  ) {
    help.IconComponent = <Burger width={20} />;
    help.name = 'Меню';
  }

  return isMobile ? (
    <>
      {/* Скрываем бургер для Альфы */}
      {openSidebar && !isPartner('alfa') && (
        <MobileMenu openSidebar={openSidebar} logIn={logIn} />
      )}
    </>
  ) : (
    <DesktopMenu
      className={className}
      showAuthorizationBlock={isWhitelabel || Boolean(menu.profile)}
      showWishlist={Boolean(menu?.wishlist)}
      services={menu?.services}
      help={help}
      isCollapsed={isCollapsed}
      showFeedback={!isHideFeedback}
      isHomepage={isHomepage}
    />
  );
};

export default HeaderMenu;
